export const getCsrfFromCookies = () => {
  const match = document.cookie.match('(^|[^;]+)\\s*' + 'XSRF-TOKEN' + '\\s*=\\s*([^;]+)')
  return match ? match.pop() || '' : null
}
